'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _ThrowError = require('../utils/ThrowError');

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var RESPONSIVE_CLASSES = {
  'false': '',
  'true': 'img-responsive private-image--responsive'
};

var SHAPE_CLASSES = {
  'default': '',
  'circle': 'img-circle private-image--circle',
  'rounded': 'img-rounded private-image--rounded',
  'thumbnail': 'img-thumbnail private-image--thumbnail'
};

exports.default = _react2.default.createClass({
  displayName: 'UIImage',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    alt: _react.PropTypes.string.isRequired,
    bordered: _react.PropTypes.bool.isRequired,
    className: _react.PropTypes.string,
    onError: _react.PropTypes.func,
    onLoad: _react.PropTypes.func,
    responsive: _react.PropTypes.bool.isRequired,
    shape: _react.PropTypes.oneOf(Object.keys(SHAPE_CLASSES)).isRequired,
    src: _validHref2.default.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      alt: '',
      bordered: false,
      responsive: true,
      shape: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      loadFailed: false
    };
  },
  handleImageError: function handleImageError(evt) {
    var onError = this.props.onError;

    this.setState({
      loadFailed: true
    });
    (0, _Functions.callIfPossible)(onError, evt);
  },
  handleImageLoad: function handleImageLoad(evt) {
    var onLoad = this.props.onLoad;

    this.setState({
      loadFailed: false
    });
    (0, _Functions.callIfPossible)(onLoad, evt);
  },
  getClassName: function getClassName(_ref) {
    var bordered = _ref.bordered,
        className = _ref.className,
        responsive = _ref.responsive,
        shape = _ref.shape;

    return (0, _reactUtils.classNames)('private-image', RESPONSIVE_CLASSES[responsive], SHAPE_CLASSES[shape], className, {
      'image-load-failed': this.state.loadFailed,
      'private-image--bordered': bordered
    });
  },
  render: function render() {
    var _props = this.props,
        bordered = _props.bordered,
        className = _props.className,
        responsive = _props.responsive,
        shape = _props.shape,
        src = _props.src,
        rest = _objectWithoutProperties(_props, ['bordered', 'className', 'responsive', 'shape', 'src']);

    if ((0, _UnsafeUrl.isUnsafeUrl)(src)) {
      (0, _ThrowError.throwErrorAsync)(new Error('UIImage: Detected XSS attempt! src="' + src + '"'));
    }

    return _react2.default.createElement('img', _extends({}, rest, {
      className: this.getClassName({ bordered: bordered, className: className, responsive: responsive, shape: shape }),
      key: src,
      onError: this.handleImageError,
      onLoad: this.handleImageLoad,
      src: (0, _UnsafeUrl.isUnsafeUrl)(src) ? null : src
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/image/UIImage.js
// module id = 62
// module chunks = 0 1